import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6rem 1rem;
  text-align: center;
  min-height: 60vh;
`;

export const Title = styled.h1`
  font-size: 3rem;
  color: var(--secondary-color);
  margin-bottom: 1rem;
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
  max-width: 600px;
`;

export const HomeButton = styled(Link)`
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  font-weight: 600;
  transition: all 0.3s;
  
  &:hover {
    background-color: var(--secondary-color);
    transform: translateY(-2px);
    color: white;
  }
`;
